module.exports = __webpack_public_path__ + "static/img/light.58df0c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneService/light.png
// module id = 2vAY
// module chunks = 0